// @flow
export const setupDevice = (configuration) => ({
  type: 'DEVICE_SETUP',
  payload: configuration
});
